if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.pendingProgrammaticMediaId = null;
this.pendingProgrammaticMediaTimeout = null;

    if (this.elements.viewer) {
  this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 150));
}
if (this.elements.thumbnails) {
        this.setThumbnailNaturalOrder();
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.setupMobileThumbnailNavigation();
        this.updateActiveThumbnailVisibility();
      }
// Autoplay is scheduled by td-gallery-autoplay after the hero image is ready.
this.setupDesktopViewerNavigation();
    }

setupDesktopViewerNavigation() {
  if (!this.elements.viewer || !this.closest('[id^="MainProduct-"]')) return;
  if (this.dataset.tdDesktopArrowsReady === 'true') return;

  const list = this.elements.viewer.querySelector('.product__media-list');
  if (!list) return;

  const controls = document.createElement('div');
  controls.className = 'td-gallery-desktop-arrows';
  controls.setAttribute('role', 'group');
  controls.setAttribute('aria-label', 'Navegación de imágenes del producto');
  controls.hidden = true;

  const previousButton = this.createDesktopViewerArrow('previous', 'Ver imagen anterior');
  const nextButton = this.createDesktopViewerArrow('next', 'Ver imagen siguiente');

  if (list.id) {
    previousButton.setAttribute('aria-controls', list.id);
    nextButton.setAttribute('aria-controls', list.id);
  }

  controls.appendChild(previousButton);
  controls.appendChild(nextButton);

  this.desktopViewerNavigation = {
    controls,
    list,
    mediaQuery: window.matchMedia('(min-width: 990px)'),
    syncFrame: null,
  };

  const navigate = (direction, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.navigateDesktopViewer(direction);
  };

  previousButton.addEventListener('click', navigate.bind(this, 'previous'));
  nextButton.addEventListener('click', navigate.bind(this, 'next'));

  this.desktopViewerNavigationObserver = new MutationObserver(() => {
    this.scheduleDesktopViewerNavigationSync();
  });

  this.desktopViewerNavigationObserver.observe(list, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'style'],
  });

  this.elements.viewer.addEventListener('slideChanged', () => {
    this.scheduleDesktopViewerNavigationSync();
  });

  const onBreakpointChange = () => this.scheduleDesktopViewerNavigationSync();
  if (this.desktopViewerNavigation.mediaQuery.addEventListener) {
    this.desktopViewerNavigation.mediaQuery.addEventListener('change', onBreakpointChange);
  } else if (this.desktopViewerNavigation.mediaQuery.addListener) {
    this.desktopViewerNavigation.mediaQuery.addListener(onBreakpointChange);
  }

  this.dataset.tdDesktopArrowsReady = 'true';
  this.syncDesktopViewerNavigation();
}

createDesktopViewerArrow(direction, label) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `td-gallery-arrow td-gallery-arrow--${direction}`;
  button.setAttribute('aria-label', label);
  button.dataset.direction = direction;

  button.innerHTML = direction === 'previous'
    ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 18 9 12l6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  return button;
}

getDesktopViewerItems() {
  if (!this.desktopViewerNavigation) return [];

  return Array.from(this.desktopViewerNavigation.list.children).filter((item) => {
    return item.matches('.product__media-item[data-media-id]') &&
      !item.hidden &&
      item.style.display !== 'none';
  });
}

getDesktopViewerActiveItem(items = this.getDesktopViewerItems()) {
  return items.find((item) => item.classList.contains('is-active')) || items[0] || null;
}

scheduleDesktopViewerNavigationSync() {
  const state = this.desktopViewerNavigation;
  if (!state || state.syncFrame) return;

  state.syncFrame = window.requestAnimationFrame(() => {
    state.syncFrame = null;
    this.syncDesktopViewerNavigation();
  });
}

syncDesktopViewerNavigation() {
  const state = this.desktopViewerNavigation;
  if (!state) return;

  const items = this.getDesktopViewerItems();
  const activeItem = this.getDesktopViewerActiveItem(items);
  const shouldHide = !state.mediaQuery.matches || items.length < 2 || !activeItem;

  if (state.controls.hidden !== shouldHide) {
    state.controls.hidden = shouldHide;
  }

  if (!shouldHide && state.controls.parentElement !== activeItem) {
    activeItem.appendChild(state.controls);
  }
}

navigateDesktopViewer(direction) {
  const items = this.getDesktopViewerItems();
  if (items.length < 2) return;

  const activeItem = this.getDesktopViewerActiveItem(items);
  const currentIndex = Math.max(items.indexOf(activeItem), 0);
  const movement = direction === 'previous' ? -1 : 1;
  const nextIndex = (currentIndex + movement + items.length) % items.length;
  const nextItem = items[nextIndex];

  if (!nextItem || !nextItem.dataset.mediaId) return;

  this.setActiveMedia(nextItem.dataset.mediaId, false);
  this.scheduleDesktopViewerNavigationSync();
}

pauseDeferredMedia(deferredMedia) {
  if (!deferredMedia) return;

  const video = deferredMedia.querySelector('video');
  if (video) video.pause();

  const youtubeVideo = deferredMedia.querySelector('.js-youtube');
  if (youtubeVideo && youtubeVideo.contentWindow) {
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }

  const vimeoVideo = deferredMedia.querySelector('.js-vimeo');
  if (vimeoVideo && vimeoVideo.contentWindow) {
    vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*');
  }
}
onSlideChanged(event) {
  const activeMedia = event.detail.currentElement;
  if (!activeMedia || !activeMedia.dataset.mediaId) return;

  this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
    element.classList.toggle('is-active', element === activeMedia);
  });

  this.playActiveMedia(activeMedia);

  if (!this.elements.thumbnails) return;
  const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ activeMedia.dataset.mediaId }"]`);
  this.setActiveThumbnail(thumbnail);
}

setActiveMedia(mediaId, prepend) {
  const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
  if (!activeMedia) return;



  this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
    element.classList.remove('is-active');
  });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
         activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }
setActiveThumbnail(thumbnail) {
  if (!this.elements.thumbnails || !thumbnail) return;

  this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));

  const thumbnailButton = thumbnail.querySelector('button');
  if (thumbnailButton) thumbnailButton.setAttribute('aria-current', true);

  this.updateActiveThumbnailVisibility(thumbnail);
}

setThumbnailNaturalOrder() {
  if (!this.elements.thumbnails) return;

  this.elements.thumbnails.querySelectorAll('.thumbnail-list__item[data-target]').forEach((item, index) => {
    if (!item.dataset.thumbnailInitialPosition) item.dataset.thumbnailInitialPosition = String(index + 1);
    if (!item.dataset.mediaNaturalPosition) item.dataset.mediaNaturalPosition = item.dataset.mediaPosition || String(index + 1);
  });
}

getThumbnailNaturalPosition(item) {
  const naturalPosition = Number(item.dataset.mediaNaturalPosition);
  if (Number.isFinite(naturalPosition)) return naturalPosition;

  const initialPosition = Number(item.dataset.thumbnailInitialPosition);
  return Number.isFinite(initialPosition) ? initialPosition : 0;
}

getThumbnailItemsInNaturalOrder() {
  if (!this.elements.thumbnails) return [];

  return Array.from(this.elements.thumbnails.querySelectorAll('.thumbnail-list__item[data-target]')).sort((itemA, itemB) => {
    const positionDelta = this.getThumbnailNaturalPosition(itemA) - this.getThumbnailNaturalPosition(itemB);
    if (positionDelta !== 0) return positionDelta;

    const initialPositionA = Number(itemA.dataset.thumbnailInitialPosition) || 0;
    const initialPositionB = Number(itemB.dataset.thumbnailInitialPosition) || 0;
    return initialPositionA - initialPositionB;
  });
}

isThumbnailAvailable(item) {
  return Boolean(item) && !item.hidden && item.style.display !== 'none';
}

shouldUseMobileThumbnailWindow() {
  return window.matchMedia('(max-width: 749px)').matches;
}

getMobileThumbnailWindow(activeThumbnail, availableItems, limit = 3) {
  if (!activeThumbnail || !availableItems.length) return [];

  const activeIndex = availableItems.indexOf(activeThumbnail);
  if (activeIndex < 0) return [];

  const windowItems = [];
  const maxItems = Math.min(limit, Math.max(availableItems.length - 1, 0));

  const pushItem = (item) => {
    if (!item || item === activeThumbnail || windowItems.includes(item)) return;
    windowItems.push(item);
  };

  /*
    Mobile behavior:
    - If the active media is the first one, show the next 3.
    - Otherwise, always keep the previous media visible.
    - Then fill with the next 2 media items.
  */

  if (activeIndex > 0) {
    pushItem(availableItems[activeIndex - 1]);
  }

  for (let offset = 1; windowItems.length < maxItems && offset < availableItems.length; offset += 1) {
    pushItem(availableItems[(activeIndex + offset) % availableItems.length]);
  }

  for (let offset = 1; windowItems.length < maxItems && offset < availableItems.length; offset += 1) {
    pushItem(availableItems[(activeIndex - offset + availableItems.length) % availableItems.length]);
  }

  return windowItems;
}

restoreThumbnailsNaturalOrder(thumbnailItems = this.getThumbnailItemsInNaturalOrder()) {
  if (!this.elements.thumbnails || !this.elements.thumbnails.slider) return;

  thumbnailItems.forEach((item) => this.elements.thumbnails.slider.appendChild(item));
}

applyMobileThumbnailWindow(activeThumbnail, thumbnailItems, availableItems) {
  if (!this.elements.thumbnails || !this.elements.thumbnails.slider || !activeThumbnail) return;

  const visibleWindowItems = this.getMobileThumbnailWindow(activeThumbnail, availableItems, 3);
  const visibleWindowSet = new Set(visibleWindowItems);

  thumbnailItems.forEach((item) => {
    const isActive = item === activeThumbnail;
    const isAvailable = availableItems.includes(item);

    item.classList.toggle('is-active-media-thumbnail', isActive);
    item.classList.toggle('is-thumbnail-sequence-hidden', isAvailable && !isActive && !visibleWindowSet.has(item));
  });

  const orderedItems = [
    activeThumbnail,
    ...visibleWindowItems,
    ...thumbnailItems.filter((item) => item !== activeThumbnail && !visibleWindowSet.has(item)),
  ];

  this.elements.thumbnails.slider.scrollLeft = 0;
  orderedItems.forEach((item) => this.elements.thumbnails.slider.appendChild(item));
  this.elements.thumbnails.slider.scrollLeft = 0;
}
getActiveThumbnail(thumbnailItems = this.getThumbnailItemsInNaturalOrder()) {
  return thumbnailItems.find((item) =>
    item.classList.contains('is-active-media-thumbnail') || item.querySelector('button[aria-current="true"]')
  ) || null;
}

getAdjacentAvailableThumbnail(direction) {
  const thumbnailItems = this.getThumbnailItemsInNaturalOrder();
  const availableItems = thumbnailItems.filter((item) => this.isThumbnailAvailable(item));

  if (availableItems.length < 2) return null;

  const activeThumbnail = this.getActiveThumbnail(thumbnailItems);
  const activeIndex = availableItems.indexOf(activeThumbnail);

  if (activeIndex < 0) return null;

  const targetIndex = direction === 'previous'
    ? (activeIndex - 1 + availableItems.length) % availableItems.length
    : (activeIndex + 1) % availableItems.length;

  return availableItems[targetIndex] || null;
}

setActiveAdjacentMedia(direction) {
  const targetThumbnail = this.getAdjacentAvailableThumbnail(direction);

  if (!targetThumbnail || !targetThumbnail.dataset.target) return;

  this.setActiveMedia(targetThumbnail.dataset.target, false);
}

setupMobileThumbnailNavigation() {
  if (!this.elements.thumbnails || this.elements.thumbnails.dataset.mobileWindowNavigation === 'true') return;

  const previousButton = this.elements.thumbnails.querySelector('button[name="previous"]');
  const nextButton = this.elements.thumbnails.querySelector('button[name="next"]');

  const handleClick = (direction, event) => {
    if (!this.shouldUseMobileThumbnailWindow()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.setActiveAdjacentMedia(direction);
  };

  if (previousButton) {
    previousButton.addEventListener('click', handleClick.bind(this, 'previous'), true);
  }

  if (nextButton) {
    nextButton.addEventListener('click', handleClick.bind(this, 'next'), true);
  }

  this.elements.thumbnails.dataset.mobileWindowNavigation = 'true';
}

updateMobileThumbnailNavigationButtons() {
  if (!this.elements.thumbnails || !this.shouldUseMobileThumbnailWindow()) return;

  const availableItems = this.getThumbnailItemsInNaturalOrder().filter((item) => this.isThumbnailAvailable(item));
  const canNavigate = availableItems.length > 1;

  ['previous', 'next'].forEach((buttonName) => {
    const button = this.elements.thumbnails.querySelector(`button[name="${buttonName}"]`);

    if (!button) return;

    if (canNavigate) {
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  });
}
updateActiveThumbnailVisibility(activeThumbnail = null) {
  if (!this.elements.thumbnails) return;

  this.setThumbnailNaturalOrder();

  const thumbnailItems = this.getThumbnailItemsInNaturalOrder();
  const availableItems = thumbnailItems.filter((item) => this.isThumbnailAvailable(item));
  const currentActiveThumbnail = activeThumbnail || thumbnailItems.find((item) => item.querySelector('button[aria-current="true"]'));
  const activeAvailableThumbnail = currentActiveThumbnail && availableItems.includes(currentActiveThumbnail)
    ? currentActiveThumbnail
    : availableItems.find((item) => item.querySelector('button[aria-current="true"]')) || availableItems[0] || null;

  thumbnailItems.forEach((item) => {
    item.classList.remove('is-thumbnail-sequence-hidden');
    item.classList.toggle('is-active-media-thumbnail', item === activeAvailableThumbnail);
  });

  if (activeAvailableThumbnail && this.shouldUseMobileThumbnailWindow()) {
    this.applyMobileThumbnailWindow(activeAvailableThumbnail, thumbnailItems, availableItems);
  } else {
    this.restoreThumbnailsNaturalOrder(thumbnailItems);
  }

  this.refreshThumbnailSlider();
}

refreshThumbnailSlider() {
  if (!this.elements.thumbnails) return;

  const thumbnailSlider = this.elements.thumbnails.slider;

  if (thumbnailSlider) {
    thumbnailSlider.scrollLeft = 0;
  }

  window.requestAnimationFrame(() => {
    if (!this.elements.thumbnails) return;

    if (this.elements.thumbnails.slider) {
      this.elements.thumbnails.slider.scrollLeft = 0;
    }

    if (typeof this.elements.thumbnails.resetPages === 'function') {
      this.elements.thumbnails.resetPages();
    } else if (typeof this.elements.thumbnails.initPages === 'function') {
      this.elements.thumbnails.initPages();
    }

    this.updateMobileThumbnailNavigationButtons();
  });
}
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

  playActiveMedia(activeItem) {
    if (!activeItem) return;
    this.querySelectorAll('deferred-media').forEach(media => this.pauseDeferredMedia(media));
    const model = activeItem.querySelector('product-model');
    if (model) model.loadContent(false);
    this.dispatchEvent(new CustomEvent('td:gallery-media-change', { bubbles: true }));
  }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
